import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Button, Header, Image, Modal } from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { userLanguage } from '../../../../app/common/userLanguageSchema/userLanguage';

function UserTracker() {
  const { activityStore, commonStore } = useStore();
  const [open, setOpen] = useState(false);
  const {
    selectedActivity: activity,
    usertracker,
    loadUserTracker,
  } = activityStore;

  useEffect(() => {
    loadUserTracker(activity?.id);
    // eslint-disable-next-line
  }, [activity]);

  const changeDateTime = (data: string) => {
    return new Date(data).toLocaleString();
  };

  return (
    <div className="user-tracker-small">
      <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        trigger={
          commonStore.filterModeTwo?.includes('AVLAVTB02') ? null : (
            <Button
              color="teal"
              //User Tracker
              style={{ marginTop: '10px' }}
              disabled={commonStore.filterModeZero?.includes('AVLAVTB02')}
            >
              {
                (
                  userLanguage[0].AssetViewItemLevelAllAssetsView
                    .AVLAVB04 as any
                )?.[`${commonStore.language.key}`]
              }
            </Button>
          )
        }
      >
        <Modal.Header User Tracker></Modal.Header>
        <Modal.Content
          style={{
            height: '40vh',
            overflowY: 'scroll',
            backgroundColor: '#eee',
          }}
        >
          {usertracker.length <= 0 ? (
            <Header
              as="h3"
              style={{
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              Sorry no data to show
            </Header>
          ) : (
            <VerticalTimeline>
              {usertracker.length >= 1 &&
                usertracker?.map((history: any) => (
                  <VerticalTimelineElement
                    key={history.id}
                    className="vertical-timeline-element-subtitle"
                    contentStyle={{
                      background: 'rgb(33, 150, 243)',
                      color: '#fff',
                    }}
                    contentArrowStyle={{
                      borderRight: '7px solid  rgb(33, 150, 243)',
                    }}
                    iconStyle={{
                      background: 'rgb(33, 150, 243)',
                      color: '#fff',
                    }}
                    icon={
                      <Image
                        style={{
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                        size="small"
                        avatar
                        src={history?.url || '/assets/user.png'}
                      />
                    }
                  >
                    <h3 className="vertical-timeline-element-title">
                      {history?.username} ({history?.departmentName})
                    </h3>
                    <h1 className="vertical-timeline-element-title">
                      {history?.month > 0 && history?.month + ' month'}{' '}
                      {history?.days > 0 && history?.days + ' days'}{' '}
                      {history?.hours > 0 && history?.hours + ' hr'}{' '}
                      {history?.mins > 0 && history?.mins + ' mins'}{' '}
                      {history?.sec > 0 && history?.sec + ' secs'}
                    </h1>
                    <p>From: {changeDateTime(history?.fromTime)}</p>
                    <p>To: {changeDateTime(history?.dateTime)}</p>
                    <p>{history?.status}</p>
                  </VerticalTimelineElement>
                ))}
            </VerticalTimeline>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button color="black" onClick={() => setOpen(false)}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
}

export default observer(UserTracker);
